import { adaptGraftWebsocketUrlForRuntime } from './adapt-graft-websocket-url.util'

const trimEnv = (value: string | undefined) => {
  const trimmed = value?.trim()

  return trimmed || undefined
}

const pickGraftWebserviceUrl = (webValue: string | undefined, legacyValue: string | undefined): string | undefined =>
  trimEnv(webValue) ?? trimEnv(legacyValue)

/**
 * Resolves graft websocket URLs for browser and server bundles.
 * Uses static process.env access so Next.js can inline NEXT_PUBLIC_* values on the client.
 */
const GRAFT_WEBSERVICE_URLS = {
  CONFERENCE: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_CONFERENCE_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_CONFERENCE_URL
  ),
  WORKSPACES: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_WORKSPACES_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_WORKSPACES_URL
  ),
  PROJECTS: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_PROJECTS_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_PROJECTS_URL
  ),
  GATEWAYS: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_GATEWAYS_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_GATEWAYS_URL
  ),
  ARTIFACT: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_ARTIFACT_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_ARTIFACT_URL
  ),
  USERS: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_USERS_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_USERS_URL
  ),
  REGUSERS: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_REGUSERS_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_REGUSERS_URL
  ),
  ACTIVITY: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_ACTIVITY_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_ACTIVITY_URL
  ),
  MAIL: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_MAIL_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_MAIL_URL
  ),
  MEMBERSHIPS: pickGraftWebserviceUrl(
    process.env.NEXT_PUBLIC_WEB_GRAFT_WEBSERVICE_MEMBERSHIPS_URL,
    process.env.NEXT_PUBLIC_GRAFT_WEBSERVICE_MEMBERSHIPS_URL
  ),
} as const

type GraftWebserviceName = keyof typeof GRAFT_WEBSERVICE_URLS

export function readGraftWebserviceUrl(service: string): string | undefined {
  const url = GRAFT_WEBSERVICE_URLS[service as GraftWebserviceName]
  return adaptGraftWebsocketUrlForRuntime(url)
}
